module.exports = __webpack_public_path__ + "img/6_Distal-A.0410b6bf.png";